import { ClassNames, useTheme } from '@emotion/react';
import type { FC } from 'react';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';
import * as Styled from './styled';
import type { PaginationProps } from './types';

export { PaginationWrapper } from './styled';
export * from './types';

export const Pagination: FC<PaginationProps> = (props) => {
  const { onChange, pageCount, ...rest } = props;
  const theme = useTheme();

  if (pageCount <= 1) return null;

  return (
    <ClassNames>
      {({ css: classNameCss }) => {
        const pageItemClassName = classNameCss(Styled.pageItemStyle(theme));
        const containerClassName = classNameCss(Styled.containerStyle);
        return (
          <ReactPaginate
            disableInitialCallback
            previousLabel={<FaAngleLeft />}
            nextLabel={<FaAngleRight />}
            previousClassName={pageItemClassName}
            nextClassName={pageItemClassName}
            breakClassName={pageItemClassName}
            hrefBuilder={(page, count) => (page >= 1 && page <= count ? `?page=${page}` : '#')}
            hrefAllControls
            pageClassName={pageItemClassName}
            containerClassName={containerClassName}
            onPageChange={({ selected }) => onChange?.(selected)}
            disabledClassName="disabled-navigation"
            pageCount={Math.ceil(pageCount)}
            {...rest}
          />
        );
      }}
    </ClassNames>
  );
};
